// 所有朝代
const dynastystr =
  "夏朝、商朝、春秋、战国、秦朝、西汉、东汉、晋朝、南北朝、隋朝、唐朝、宋朝、元朝、明朝、清朝";
export const dynasty = dynastystr.split("、").map((item, index) => ({
  label: item,
  value: index + 1,
}));
// 所有艺术形态
const artFormstr =
  "青铜器、玉器、甲骨文、雕塑、画像石、漆器、石窟造像、书法、绘画、唐三彩、山水画、瓷器、建筑工艺";
export const artForm = artFormstr.split("、").map((item, index) => ({
  label: item,
  value: index + 1,
}));
